import { render, staticRenderFns } from "./AudienceAuthorization.vue?vue&type=template&id=a222664c&scoped=true"
import script from "./AudienceAuthorization.vue?vue&type=script&lang=js"
export * from "./AudienceAuthorization.vue?vue&type=script&lang=js"
import style0 from "./AudienceAuthorization.vue?vue&type=style&index=0&id=a222664c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a222664c",
  null
  
)

export default component.exports